import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FeaturedTable from '../../../../../components/FeaturedTable/FeaturedTable'
import { checklistsHistoryColumns } from '../../helpers'

const ChecklistsTable = ({ data, selectedBuilding, setSelectedResident = () => {} }) => {
  const { t } = useTranslation(['checklists-dashboard'])
  return (
    <div className="ctp-checklists-wrapper-main-table dashboard-checklists-table">
      {selectedBuilding && selectedBuilding.timezone && data.length ? (
        <FeaturedTable
          columns={checklistsHistoryColumns({
            onShowDetails: setSelectedResident,
            timezone: selectedBuilding.timezone,
            t,
          })}
          data={data}
        />
      ) : (
        <div className="no-data">{t('checklists-dashboard:table.noDataMessage')}</div>
      )}
    </div>
  )
}

ChecklistsTable.propTypes = {
  data: PropTypes.array,
  selectedBuilding: PropTypes.object,
  setSelectedResident: PropTypes.func,
}

export default ChecklistsTable
